export const LOGIN_POPUP = 'LOGIN_POPUP';
export const LOGIN_CONFIRM_POPUP = 'LOGIN_CONFIRM_POPUP';
export const LOGIN_BTN = 'LOGIN_BTN';
export const LOGIN_SUCCESS_POPUP = 'LOGIN_SUCCESS_POPUP';
